import type { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'

import type { PagingSubStore } from '../../store/subStore'

import { EmptyPage } from '../exception/EmptyPage'
import type { EmptyPageProps } from '../exception/EmptyPage'
import { InfinityContent } from './InfinityContent'

type PagingContentProps = {
  emptyIcon?: EmptyPageProps['emptyIcon']
  emptyText?: string
  pagingStore: PagingSubStore<any>
  loadParam?: any
}

export const PagingContentReverse = observer(
  ({
    children,
    pagingStore: { content, isFailed, isLoading, isLoaded, list, appendOffset, load },
    emptyIcon,
    emptyText,
    loadParam,
  }: PropsWithChildren<PagingContentProps>) => {
    let appendLoadRendering = null

    if (isFailed) {
      appendLoadRendering = <EmptyPage emptyIcon={emptyIcon} content={'오류가 발생했습니다. 다시 시도해주세요'} />
    } else if (isLoading) {
      appendLoadRendering = (
        <div style={{ display: 'flex', justifyContent: 'center', height: '117px', alignItems: 'center' }}>더보기</div>
      )
    } else if (isLoaded && content?.list && content?.list.length < 1) {
      appendLoadRendering = <EmptyPage emptyIcon={emptyIcon} content={emptyText ?? '조회 가능한 내역이 없습니다.'} />
    }

    const scroll = () => {
      appendOffset()
      load(loadParam)
    }

    return (
      <>
        <InfinityContent
          length={list.length}
          hasMore={!!content?.last}
          onScroll={scroll}
          listParams={content}
          reverse={true}
        />
        {appendLoadRendering}
        {children}
      </>
    )
  },
)
